import { ActivityIndicator, Image, Platform, View } from 'react-native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import TransactionIconFocused from '../../assets/Icons/TransactionIconFocused';
import TransactionIconUnfocused from '../../assets/Icons/TransactionIconUnfocused';
import ManageLimitIconFocused from '../../assets/Icons/ManageLimitIconFocused';
import ManageLimitIconUnfocused from '../../assets/Icons/ManageLimitIconUnfocused';
import HomeIconFocused from '../../assets/Icons/HomeIconFocused';
import HomeIconUnfocused from '../../assets/Icons/HomeIcon';
import { NavigationProp, RouteProp } from '@react-navigation/native';
import TransactionScreen from '../screens/Transactions/Transactions';
import DashboardScreen from '../screens/Dashboard/Dashboard';
import EnterEmail from '../screens/EnterEmail/EnterEmail';
import VerifyEmail from '../screens/VerifyEmail/VerifyEmail';
import EmailVerification from '../screens/EmailVerification/EmailVerification';
import Faqs from '../screens/Faqs/Faq';
import ROUTE from './routes';
import VerifyPan from '../screens/VerifyPan/VerifyPan';
import InterestCalculator from '../screens/InterestCalculator/InterestCalculator';
import { BottomTabParamList, PrivateStackParamList } from './types';
import ManageLimit from '@screens/ManageLimit/ManageLimit';
import UserProfile from '../screens/UserProfile/UserProfile';
import AboutUs from '../screens/AboutUs/AboutUs';
import WebviewScreen from '../screens/Webview/WebviewScreen';
import LendingPartners from '../screens/UserProfile/LendingPartners';
import ProductDetails from '../screens/UserProfile/ProductDetails';
import ContactUs from '../screens/UserProfile/ContactUs';
import VerifyBankAccount from '@app/screens/VerifyBankAccount/VerifyBankAccount';
import BankSelect from '@app/screens/BankSelect/BankSelect';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import Loader from '../screens/Loader/Loader';
import { useEffect, useLayoutEffect, useState } from 'react';
import { useNavigation } from '@react-navigation/native';
import { checkColor, emailDefferingFlag, getParameters } from '@app/utils';
import { Theme, themeColorSet } from '@app/theme';
import LMSDasboard from '@app/screens/LMSDasboard/LMSDasboard';
import SelectRepayAmount from '@app/screens/SelectRepayAmount/SelectRepayAmount';
import EnterWithdrawalAmount from '@app/screens/EnterWithdrawalAmount/EnterWithdrawalAmount';
import ConfirmWithdrawAmount from '@app/screens/ConfirmWithdrawAmount/ConfirmWithdrawAmount';
import WithdrawalSuccess from '@app/screens/WithdrawalSuccess/WithdrawalSuccess';
import FlexiPay from '@app/screens/FlexiPay/FlexiPay';
import ConfirmPay from '@app/screens/ConfirmPay/ConfirmPay';
import InterestPayment from '@app/screens/InterestPayment/InterestPayment';
import ShortfallDetail from '@app/screens/ShortfallDetail/ShortfallDetail';
import ShortfallRepay from '@app/screens/ShortfallRepay/ShortfallRepay';
import WhatIsShortfall from '@app/screens/WhatIsShortfall/WhatIsShortfall';
import PaymentStatus from '@app/screens/PaymentStatus/PaymentStatus';
import InterestLearnMore from '@app/screens/InterestLearnMore/InterestLearnMore';
import ShortFallLearnMore from '@app/screens/ShortFallLearnMore/ShortFallLearnMore';
import RenewalLearnMore from '@app/screens/RenewalLearnMore/RenewalLearnMore';
import RenewLoan from '@app/screens/RenewLoan/RenewLoan';
import RenewalSummary from '@app/screens/RenewalSummary/RenewalSummary';
import RenewalStatus from '@app/screens/RenewalStatus/RenewalStatus';
import PleadgeMF from '@app/screens/PleadgeMF/PleadgeMF';
import PleadgeMore from '@app/screens/PleadgeMore/PleadgeMore';
import RemovePledge from '@app/screens/RemovePledge/RemovePledge';
import AccountDetails from '@app/screens/AccountDetails/AccountDetails';
import UpdatePhoneNumber from '@app/screens/UpdatePhoneNumber/UpdatePhoneNumber';
import MyLoanDetails from '@app/screens/MyLoanDetails/MyLoanDetails';
import PledgeHistory from '@app/screens/PledgeHistory/PledgeHistory';
import HowtoCloseAccount from '@app/screens/HowtoCloseAccount/HowtoCloseAccount';
import SelectCloseReason from '@app/SelectCloseReason/SelectCloseReason';
import ConfirmLoanDetails from '@app/screens/ConfirmLoanDetails/ConfirmLoanDetails';
import UnpledgeInstructions from '@app/screens/UnpledgeInstructions/UnpledgeInstructions';
import PledgeDetails from '@app/screens/PledgeDetails/PledgeDetails';
import ElevateLanding from '@app/screens/ElevateLanding/ElevateLanding';
import OldForeClosure from '@app/screens/OldForeClosure/OldForeClosure';
import RepayDues from '@app/screens/RepayDues/RepayDues';
import ElevateSwitching from '@app/screens/ElevateSwitching/ElevateSwitching';
import UpdateSuccess from '@app/screens/UpdateSuccess/UpdateSuccess';
import FaqScreenRevamp from '@app/screens/FaqScreenRevamp/FaqScreenRevamp';
import FaqDetailsScreenRevamp from '@app/screens/FaqDetailsRevamp/FaqDetailsRevamp';
import HelpAndSupportRevamp from '@app/screens/HelpAndSupportRevamp/HelpAndSupportRevamp';
import PaymentWebView from '../screens/PaymentWebView';
import ViewDetails from '@app/screens/ViewDetail/ViewDetails';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import AsyncStorage from '@react-native-async-storage/async-storage';
import Loading from '@app/sharedComponents/Loading/Loading';
import { updatePartnerParams } from '@app/store/slices/platformSlice';

import BankAccountAdd from '@app/screens/BankAccountAdd/BankAccountAdd';
import BankBranchSearch from '@app/screens/bankBranchSearch/BankBranchSearch';
import NameMismatch from '@app/screens/NameMismatch/NameMismatch';
import SupportingDocuments from '@screens/SupportingDocuments/SupportingDocuments';
import DigioMandateSign from '@screens/DigioMandate/DigioMandateSign';
import AssetPledge from '@app/screens/AssetPledge/AssetPledge';
import DSPAgreement from '@app/screens/DspKfs/DSPAgreement';
import MFCentralEvaluateFunds from "@screens/MFCentral/MFCentralEvaluateFunds/MFCentralEvaluateFunds";
import MFCentralLanding from "@screens/MFCentral/MFCentralLanding/MFCentralLanding";
import MFCentralAnchor from "@screens/MFCentral/MFCentralAnchor/MFCentralAnchor";
import KYCDocuments from '@screens/KYC/KYCDocuments/KYCDocuments';
import KYCPhotoVerification from '@screens/KYC/KYCPhotoVerification/KYCPhotoVerification';
import KYCSummary from '@app/screens/KYC/KYCSummary/KYCSummary';
import KYCResponse from "@screens/KYC/KYCResponse/KYCResponse";
import KYCRedirect from "@screens/KYC/KYCRedirect/KYCRedirect";
import LoanOffer from '@screens/LoanOffer/LoanOffer';
import KYCPhotoMisMatch from "@screens/KYC/KYCPhotoVerification/KYCPhotoMisMatch";
import KYCStepper from "@screens/KYCStepper/KYCStepper";

import CreditLoading from '@screens/CreditLoading/CreditLoading';
import DigioAutoPayProgress from '@app/screens/DigioAutoPayProgress/DigioAutoPayProgress';
import TataESign from '@app/screens/TataEsign/TataESign';
import StateSelection from '@screens/StateSelection/StateSelection';
import KycAdditonalDetails from '@screens/KYC/KYCAdditionalDetails/KycAdditonalDetails';


import FetchPortfolio from '@app/screens/FetchPortfolio/FetchPortfolio';
import LoanOfferEnhanceLimit from '@app/screens/LoanOfferEnhanceLimit/LoanOfferEnhanceLimit';
import MfPledgePortfolio from '@app/screens/MfPledgePortfolio/MfPledgePortfolio';
import CheckingLimit from '@app/screens/CheckingLimit/CheckingLimit';
import ProfolioFromRta from '@app/screens/PortfolioFromRta/ProfolioFromRta';
import SetCreditLimit from '@app/screens/SetCreditLimit/SetCreditLimit';
import Portfolio from '@app/screens/Portfolio/Portfolio';
import CheckCustomerEligibility from '@screens/CheckCustomerEligibility/CheckCustomerEligibility';
import CibilCheckLoadingScreen from '@screens/CibilCheckLoadingScreen/CibilCheckLoadingScreen';
import { removeUrlWithoutReload } from '@voltmoney/micro-frontend';
import AccountBlocked from '@app/screens/AccountBlocked/AccountBlocked';
import ManageLimitLandingPage from '@app/screens/MangeLimitLandingPage/ManageLimitLandingPage';
import UnlockLimitLanding from '@app/screens/UnlockLimitLanding/UnlockLimitLanding';
import MfdShareLinkInit from '@app/screens/MfdShareLinkInit/MfdShareLinkInit';
import MfdShareLinkEndJourney from '@app/screens/MfdShareLinkEndJourney';
import RedirectionScreen from '@app/screens/RedirectionJourney/RedirectionScreen';
import BajajShutDownInfoScreen from '@app/screens/BajajShutDownInfoScreen';
import { PLATFORM_NAME } from '@app/types/regix';
import PaymentLoader from '@app/screens/PaymentLoader/PaymentLoader';
import LoaderLMS from '@app/screens/Loader/LoaderLMS';
import { baseUrl, baseUrlConfig } from '@app/api/apis';
import { useTheme } from '@shopify/restyle';
const Stack = createNativeStackNavigator<PrivateStackParamList>();
const Tab = createBottomTabNavigator<BottomTabParamList>();

type TabNavigationProps = {
  navigation: NavigationProp<BottomTabParamList>;
};

type PrivateRoutesProps = {
  userDetails: {
    linkedApplications: Array<{
      currentStepId: string;
    }>;
    linkedBorrowerAccounts: Array<{
      accountHolderEmail: string | null;
    }>;
    linkedCredits: Array<{
      creditId: string;
    }>;
  };
};


type MyTabsProps = {
  navigation: NativeStackNavigationProp<PrivateStackParamList>;
};

function MyTabs({ navigation }: MyTabsProps) {
  const { showVoltBottomNavBar, showManageLimit, showTransactionHistory, showHome, target } = useAppSelector((state) => state.platformParams);
  const showBottomBar = showVoltBottomNavBar && ([showManageLimit, showTransactionHistory, showHome].filter(Boolean).length >= 2);
  const isLMSUser = useAppSelector((state) => state.commonReducer.isLMSUser);
  const isBFLLoan = useAppSelector((state) => state.commonReducer.isBFLLoan);

  const [loading, setLoading] = useState(true);
  const dispatch = useAppDispatch();
  const { colors } = useTheme<Theme>()
  useEffect(() => {
    AsyncStorage.getItem('show_lms_revamp')
      .then((res) => {
        // console.log('privateshow_lms_revamp',res)
        if (res === 'false' && isLMSUser !== false) {
          navigation.navigate('SPLASHSCREEN');
        }
      })
      .finally(() => {
        setLoading(false);
      })

  }, [isLMSUser])

  if (isLMSUser === null || loading) {
    return <Loading />
  }

  const fetchInitialRoute = () => {
    if (Platform.OS === 'web') {
      removeUrlWithoutReload("target")
    }
    if (!target) {
      return ROUTE.DASHBOARD_SCREEN;
    }
    setTimeout(() => {
      dispatch(updatePartnerParams({ "target": "" }))
    }, 1000)
    if (target === 'transaction') {
      return ROUTE.TRANSACTION_SCREEN;
    }
    if (target === 'manageLimit') {
      return ROUTE.MANAGE_LIMIT_SCREEN;
    } else {
      return ROUTE.DASHBOARD_SCREEN;
    }

  }



  return (
    <Tab.Navigator
      initialRouteName={fetchInitialRoute()} // Set Transactions as the default tab
      screenOptions={{
        headerShown: false,
        tabBarLabelStyle: { fontSize: 12, fontFamily: "Inter" },
        tabBarStyle: {
          backgroundColor: themeColorSet['bg-fill-primary'], borderTopColor: themeColorSet['border-secondary'], borderTopWidth: 1,
          paddingBottom: 8,
          paddingTop: 8,
          height: 60,
          display: showBottomBar && !isBFLLoan ? 'flex' : 'none',
        },
        tabBarActiveTintColor: themeColorSet['text-action-primary'],
        tabBarInactiveTintColor: '#667085',
        title: 'Volt - Unlock cash from your mutual funds saving',
      }}
    >
      <Tab.Screen
        options={{
          tabBarLabel: 'Home',
          tabBarLabelPosition: 'below-icon',
          tabBarIcon: ({ focused }) => (
            <HomeIconFocused color={focused ? colors['icon-action-primary'] : colors["icon-secondary"]} color1={focused ? colors['icon-emphasis-primary'] : colors["icon-disabled"]} />
          ),
        }}
        name={ROUTE.DASHBOARD_SCREEN}
        component={isLMSUser ? LMSDasboard : DashboardScreen}
      />
      {showTransactionHistory && <Tab.Screen
        options={{
          tabBarLabel: 'Transactions',
          tabBarLabelPosition: 'below-icon',
          tabBarIcon: ({ focused }) => (
            <TransactionIconFocused color={focused ? colors['icon-action-primary'] : colors['icon-disabled']} color1={focused ? colors['icon-emphasis-primary'] : colors["icon-secondary"]}/>
          ),
        }}
        name={ROUTE.TRANSACTION_SCREEN}
        component={TransactionScreen}
      />}
      {showManageLimit && <Tab.Screen
        options={{
          tabBarLabel: 'Manage Limit',
          tabBarLabelPosition: 'below-icon',
          tabBarIcon: ({ focused }) => (
            <ManageLimitIconFocused color={focused ? colors['icon-action-primary'] : colors['icon-disabled']} color1={focused ? colors['icon-emphasis-primary'] : colors["icon-secondary"]}/>
          ),
        }}
        name={ROUTE.MANAGE_LIMIT_SCREEN}
        component={ManageLimit}
      />}
    </Tab.Navigator>
  );
}

const PrivateRoutes = ({ userDetails }: PrivateRoutesProps) => {
  const currentStepName = userDetails?.linkedApplications[0]?.currentStepId as keyof typeof ROUTE | undefined;
  const userEmailNotExist = userDetails?.linkedBorrowerAccounts[0]?.accountHolderEmail === null;
  const platformParams = useAppSelector((state) => state.platformParams);
  const platform = platformParams?.platform;
  const applicationStatus = userDetails?.linkedApplications[0]?.applicationState;

  const firebaseParams = useAppSelector((state) => state.firebaseParams);
  const isProd = baseUrl === baseUrlConfig['production'];

  const isLOSRevampEnabled = (
    (isProd ? firebaseParams?.los_revamp === 'true' : firebaseParams?.los_revamp_staging === 'true') &&
    platform !== PLATFORM_NAME.TDL
  );

  const isLOSRevampEnabledMobile = firebaseParams?.los_revamp_app === 'true';


  const isLOSRevampEnabledSuper = Platform.select({
    ios: isLOSRevampEnabledMobile,
    android: isLOSRevampEnabledMobile,
    web: isLOSRevampEnabled
  });

  const emailDefferingFeatureFlag = emailDefferingFlag();

  const [, setInitialRouteName] = useState<keyof PrivateStackParamList | null>(null);

  const isLMSUser = useAppSelector((state) => state.commonReducer.isLMSUser);

  const navigation = useNavigation()
  const { showHome } = platformParams
  useEffect(() => {
    if (Platform.OS !== 'web') {
      // BootSplash.hide({ fade: true })
    }
  }, [])

  // useEffect(() => {
  //   const creditId = userDetails?.linkedCredits[0]?.creditId || null; // check if creditId is present then navigate to splash screen for LMS flow
  //   const currentStepName = userDetails?.linkedApplications[0]?.currentStepId as keyof typeof ROUTE | undefined;
  //   if(creditId!==null || currentStepName === null){
  //     navigation.navigate("SPLASHSCREEN")
  //     return;
  //   }
  // }, [userDetails])



  if (applicationStatus === 'BLOCKED' || applicationStatus === 'DENIED') {
    return <AccountBlocked />
  }


  return (
    <Stack.Navigator
      screenOptions={{
        title: 'Volt - Unlock cash from your mutual funds saving',
        // animation: 'fade', // iOS-like horizontal slide animation
        // gestureEnabled: true,         // Enable swipe gestures
        // gestureDirection: 'horizontal', // Direction of the swipe gesture
      }}
      initialRouteName={Platform.OS === 'web' ? ROUTE.LOADING : ROUTE.HOME}
    >
      {Platform.OS === 'web' && <Stack.Screen
        name={ROUTE.LOADING}
        component={isLOSRevampEnabled ? Loader : LoaderLMS}
        options={{ headerShown: false }}
      />}
      {(showHome || isLMSUser) &&
        <Stack.Screen
          name="HOME"
          component={MyTabs}
          options={{ headerShown: false }}
        />}
      {
        (emailDefferingFeatureFlag || userEmailNotExist) && <Stack.Screen
          name={ROUTE.VERIFY_EMAIL}
          component={VerifyEmail}
          options={{ headerShown: false }}
        />
      }
      {
        (emailDefferingFeatureFlag || userEmailNotExist) && <Stack.Screen
          name={ROUTE.ENTER_EMAIL}
          component={EnterEmail}
          options={{ headerShown: false }}
        />
      }
      <Stack.Screen
        name={ROUTE.KYC_PAN_VERIFICATION}
        component={VerifyPan}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.USER_PROFILE}
        component={UserProfile}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.ABOUT_US}
        component={AboutUs}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.WEBVIEW_SCREEN}
        component={WebviewScreen}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.LENDING_PARTNERS}
        component={LendingPartners}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.PRODUCT_DETAILS}
        component={ProductDetails}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.CONTACT_US}
        component={ContactUs}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.FAQ}
        component={Faqs}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.INTEREST_CALCULATOR}
        component={InterestCalculator}
        options={{ headerShown: false }}
      />

      {isLOSRevampEnabledSuper && (
        <>
          <Stack.Screen
            name={ROUTE.BANK_ACCOUNT_VERIFICATION}
            component={VerifyBankAccount}
            options={{
              headerShown: false,
            }}
          />
          <Stack.Screen
            name={ROUTE.KYC_DOCUMENTS}
            component={KYCDocuments}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.KYC_DIGIO_RESPONSE}
            component={KYCResponse}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.KYC_DIGIO_REDIRECT}
            component={KYCRedirect}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.KYC_PHOTO_VERIFICATION}
            component={KYCPhotoVerification}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.KYC_SUMMARY}
            component={KYCSummary}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.BANK_SELECT}
            component={BankSelect}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.BANK_ACCOUNT_ADD}
            component={BankAccountAdd}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.BANK_BRANCH_SEARCH}
            component={BankBranchSearch}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.NAME_MISMATCH}
            component={NameMismatch}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.SUPPORTING_DOCUMENT}
            component={SupportingDocuments}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.DIGIO_MANDATE_SIGN}
            component={DigioMandateSign}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.ASSET_PLEDGE}
            component={AssetPledge}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.DSP_KFS}
            component={DSPAgreement}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.MFC_FETCH_EVALUTE_FUNDS}
            component={MFCentralEvaluateFunds}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.MFC_FETCH_LANDING}
            component={MFCentralLanding}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.MFC_FETCH_ANCHOR}
            component={MFCentralAnchor}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.PLEDGE_CONFIRMATION}
            component={LoanOffer}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.KYC_PHOTO_MISMATCHH}
            component={KYCPhotoMisMatch}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.KYC_STEPPER}
            component={KYCStepper}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.CREDIT_LOADING}
            component={CreditLoading}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.DIGIO_AUTOPAY_INPROGRESS}
            component={DigioAutoPayProgress}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.SIGN_DESK_ESIGN}
            component={TataESign}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.STATE_SELECTION}
            component={StateSelection}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.MF_FETCH_PORTFOLIO}
            options={{ headerShown: false }}
          >
            {(props) => <FetchPortfolio {...props} isFullScreen={true} />}
          </Stack.Screen>
          <Stack.Screen
            name={ROUTE.MF_PLEDGE_PORTFOLIO}
            component={MfPledgePortfolio}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.CHECKING_LIMIT}
            component={CheckingLimit}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.PORTFOLIO_FROM_RTA}
            component={ProfolioFromRta}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.SET_CREDIT_LIMIT}
            component={SetCreditLimit}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.PORTFOLIO}
            component={Portfolio}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.KYC_ADDITIONAL_DETAILS}
            component={KycAdditonalDetails}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.LOAN_OFFER_ENHANCE_LIMIT}
            component={LoanOfferEnhanceLimit}
            options={{ headerShown: false }}
          />

          <Stack.Screen
            name={ROUTE.CHECK_CUSTOMER_ELIGIBILITY}
            component={CheckCustomerEligibility}
            options={{ headerShown: false }}
          />

          <Stack.Screen
            name={ROUTE.CIBIL_CHECK_LOADING_SCREEN}
            component={CibilCheckLoadingScreen}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.ELEVATE_LANDING}
            component={ElevateLanding}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.BLOCKED}
            component={AccountBlocked}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.MANAGE_LIMIT_LANDING}
            component={ManageLimitLandingPage}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.UNLOCK_LIMIT_LANDING}
            component={UnlockLimitLanding}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.MFD_SHARE_LINK_END_JOURNEY}
            component={MfdShareLinkEndJourney}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.MFD_SHARE_LINK_INIT_AUTH}
            component={MfdShareLinkInit}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.REDIRECTION_JOURNEY_SCREEN}
            component={RedirectionScreen}
            options={{ headerShown: false }}
          />
        </>
      )}
      <Stack.Screen
        name={ROUTE.WITHDRAW_AMOUNT}
        component={EnterWithdrawalAmount}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.CONFIRM_WITHDRAW_AMOUNT}
        component={ConfirmWithdrawAmount}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.WITHDRAW_SUCCESS}
        component={WithdrawalSuccess}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.FLEXI_PAY}
        component={FlexiPay}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.CONFIRM_PAYMENT_DETAILS}
        component={ConfirmPay}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.INTEREST_PAYMENT}
        component={InterestPayment}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.SHORTFALL_DETAILS}
        component={ShortfallDetail}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.SHORTFALL_REPAY}
        component={ShortfallRepay}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.WHAT_IS_SHORTFALL}
        component={WhatIsShortfall}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.PAYMENT_STATUS}
        component={PaymentStatus}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.INTEREST_LEARN_MORE}
        component={InterestLearnMore}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.SHOTFALL_LEARN_MORE}
        component={ShortFallLearnMore}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.RENEWAL_LEARN_MORE}
        component={RenewalLearnMore}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.RENEW_LOAN}
        component={RenewLoan}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.VERIFY_RENEW_LOAN}
        component={RenewalSummary}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.RENEWAL_STATUS}
        component={RenewalStatus}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.PLEADGE_MF}
        component={PleadgeMF}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.PLEDGE_MORE}
        component={PleadgeMore}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.REMOVE_PLEGE}
        component={RemovePledge}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.ACCOUNT_DETAILS}
        component={AccountDetails}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.UPDATE_PHONE_EMAIL}
        component={UpdatePhoneNumber}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.LOAN_DETAILS}
        component={MyLoanDetails}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.PLEDGE_HISTORY}
        component={PledgeHistory}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.OLD_FORECLOSURE}
        component={OldForeClosure}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.REPAY_DUES}
        component={RepayDues}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.HOW_TO_CLOSE_ACCOUNT}
        component={HowtoCloseAccount}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.SELECT_CLOSE_REASON}
        component={SelectCloseReason}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.CONFIRM_LOAN_DETAILS}
        component={ConfirmLoanDetails}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.UNPLEDGE_INSTRUCTIONS}
        component={UnpledgeInstructions}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.PLEDGE_DETAILS}
        component={PledgeDetails}
        options={{ headerShown: false }}
      />

      <Stack.Screen
        name={ROUTE.ELEVATE_SWITCHING}
        component={ElevateSwitching}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.UPDATE_ACCOUNT_SUCCESS}
        component={UpdateSuccess}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.HELP_AND_SUPPORT_SCREEN_REVAMP}
        component={HelpAndSupportRevamp}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.FAQ_SCREEN_REVAMP}
        component={FaqScreenRevamp}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.FAQ_DETAILS_SCREEN_REVAMP}
        component={FaqDetailsScreenRevamp}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.PAYMENT_WEBVIEW}
        component={PaymentWebView}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.VIEW_DETAILS}
        component={ViewDetails}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.PAYMENT_LOADER}
        component={PaymentLoader}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.BAJAJ_SHUTDOWN}
        component={BajajShutDownInfoScreen}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.EMAIL_VERIFICATION}
        component={EmailVerification}
        options={{ headerShown: false }}
      />
    </Stack.Navigator>
  );
};
export default PrivateRoutes;
